module.exports = __webpack_public_path__ + "static/media/g1_traveler.1b169750.png";